import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpService } from './http.service';
import { UtilService } from './util.service';

@Injectable()
export class HcaManagementService {
    constructor(private http: HttpService, private utilService: UtilService) {}

    showadmins() {
     return this.http.get(`/getAllHotelChainAdmins`)
     .map(res => res.json())
     .catch(this.utilService.handleError);
    }

    saveHotelChain(data) {
      return this.http.post(`/saveHotelChainAdmin`,data)
      .map(res => res.json())
      .catch(this.utilService.handleError);
    }

    getDetails (id){
        return this.http.get(`/getHotelChainAdmin/`+id)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }
    
    updateAdmin(data){
        return this.http.post(`/editHotelChainAdmin`,data)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

    changeHcaStatus(id,status) {
        return this.http.get(`/activateOrDeactivateHotelChain?hotelChainId=`+id+`&statusChange=`+status)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }
    
    updateLoginAccess(access) {
        let hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
        return this.http.get(`/updateLoginAccess?hotelChainId=`+hotelChainId+`&isAllowAccess=`+access)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }

    getLoginAccess() {
        let hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
        return this.http.get(`/getLoginAccess/${hotelChainId}`)
        .map(res => res.json())
        .catch(this.utilService.handleError);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hca-management.service.ts